import React from 'react';

import ArrowCircleSVG from '@app/images/ArrowCircleSVG';

const CardLink = (props) => {
	return (
		<div className="card-link">
			<h4 className="card-link__title">
				<a href={props.url} target="_blank" rel="noopener noreferrer">
					{props.title}
				</a>
			</h4>
			{props.description && <p className="card-link__text">{props.description}</p>}
			{props.url && (
				<>
					<a href={props.url} className="card-link__link" target="_blank" rel="noopener noreferrer">
						{props.url}
					</a>
					<a href={props.url} className="link-more" target="_blank" rel="noopener noreferrer">
						<ArrowCircleSVG />
					</a>
				</>
			)}
		</div>
	);
};

export default CardLink;
